"use client"

export const getKlaviyoProfile = async (email: string) => {
    try {
        const response = await fetch(
            `/api/klaviyo/klaviyo-get-klaviyo-profile?email=${email}`,
            {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            }
        )

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        return await response.json()
    } catch (error) {
        console.error("Error fetching Klaviyo profile:", error)
        throw error
    }
}

export default getKlaviyoProfile
